import { AppError } from './app-error';

export const isAppError = (error: unknown): error is AppError =>
	error instanceof AppError;
